module.exports = __webpack_public_path__ + "static/media/img-features-digital-signage.2dda4979.png";